import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { subscribe } from '../api'
import Modal from './Modal'

export default class SubscriptionModal extends Component {
	constructor(props) {
		super(props)
		// {email, accountId, token}
		this.state = {
			email: props.sessionEmail,
			firstName: '',
			submitting: false,
			accountId: props.accountId,
			token: props.accessToken,
			error: null
		}
	}

	// Handle them dismissing the modal
	modalDismissed = () => {		
		this.props.modalDismissed()
	}

	handleSubmit = async (e) => {
		e.preventDefault()
		this.setState({submitting: true})
		let {email, accountId, token, firstName} = this.state
		let { accountName } = this.props
		
		const res = await subscribe({email, accountId, token, accountName, firstName})
		
		if(res) {
			if(window.mixpanel) {
				window.mixpanel.track('[AdScore] - AdMonitor Subscription Request', {
					email, ad_account_id: accountId
				})
			}
			this.setState({submitting: false, error: null})
			this.props.submitSuccess()
		} else {
			this.setState({submitting: false, error: 'Subscription failed. Please try again!'})
		}
	}

	handleInputChange = ({target: {id, type, value, checked}}) => {
		const newValue = type === 'checkbox' ? checked : value
		this.setState(() => {return {[id]: newValue}})
	}

	renderError = () => {
		if(this.state.error) {
			return (
				<span className='error'>{this.state.error}</span>
			)
		} else {
			return (<span></span>)
		}
	}

	render() {
		let {email, firstName, submitting} = this.state
		return (
			<Modal display={this.props.display} modalDismissed={this.modalDismissed}>
				<div className='subscription-modal'>
					{this.renderError()}
					<img src="https://www.datocms-assets.com/3323/1528912402-mail.png" alt="mail icon" />
					<p className='cta_paragraph'>Get monthly score updates and benchmarks in your inbox.</p>
					<form onSubmit={this.handleSubmit}>
						<input id="firstName" type="text" placeholder="First Name" value={firstName || ''} onChange={this.handleInputChange} />
						<input id="email" type="email" placeholder="Email Address" value={email || ''} onChange={this.handleInputChange} />
						<span id='terms'>By hitting &quot;Subscribe,&quot; you agree that we may access your Facebook ad account to generate ongoing insights and reports in connection with your subscription. You may unsubscribe at any time.</span>
						<button className="cta" type="button" onClick={this.handleSubmit} disabled={submitting}>
							{submitting ? 'Submitting Your Info...' : 'Subscribe'}
						</button>
					</form>
				</div>
			</Modal>
		)
	}
}

SubscriptionModal.propTypes = {
	accessToken: PropTypes.string,
	accountId: PropTypes.string,
	accountName: PropTypes.string,
	sessionEmail: PropTypes.string,
	display: PropTypes.bool,
	modalDismissed: PropTypes.func,
	submitSuccess: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/SubscriptionModal.js